import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions as notifications } from '@saucelabs/sl-container-notifications';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../tracking';
import { GlobalState } from '../../reducers';
import types from './types';
import { getRoundedFileSizeInMB } from '../../utils';
import { UploadToSdFile } from './records';

const uploadToSdCard = createAsyncThunk(
  types.MOBILE_DEVICE_UPLOAD_TO_SD,
  async (file: UploadToSdFile, { dispatch, getState, rejectWithValue }) => {
    try {
      const fileSizeInMB = getRoundedFileSizeInMB(file.size);
      const state = getState() as GlobalState;
      // TODO: Fix typing once the sessionReducer is typed
      const device: any = state.apps.manual.session.get('device'); // eslint-disable-line @typescript-eslint/no-explicit-any
      const { name: deviceName }: any = state.apps.manual.session.get('deviceDescriptor'); // eslint-disable-line @typescript-eslint/no-explicit-any

      trackEvent(MANUAL_TEST_EVENTS.START_UPLOAD_FILE_TO_SD_CARD, { deviceName, fileSizeInMB });

      const pushFileResult = await device.pushFileToDevice(file);

      if (pushFileResult.status === 'ERROR') {
        throw pushFileResult.error;
      }

      dispatch(notifications.notifySuccess(`Successfully uploaded ${file.name}`, null, undefined, undefined, true));

      trackEvent(MANUAL_TEST_EVENTS.COMPLETE_UPLOAD_FILE_TO_SD_CARD, { deviceName, fileSizeInMB });

      return pushFileResult; // eslint-disable-line @typescript-eslint/no-unsafe-return
    } catch (error) {
      dispatch(notifications.notifyDanger(`Uploading "${file.name}" failed`, null, undefined, undefined, true));

      return rejectWithValue(error);
    }
  },
);

export default {
  uploadToSdCard,
};
